import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import WebViewTitleDesc from './webViewTitleDesc.mdx';
import CaptureBillingAddressEnabledDesc from './captureBillingAddressEnabledDesc.mdx';
import ApplePayUnsupportedDesc from './applePayUnsupportedDesc.mdx';
import CheckProvidedNetworksDesc from './checkProvidedNetworksDesc.mdx';
import CardPaymentOptionsDesc from './cardPaymentOptionsDesc.mdx';
import AllowedCardNetworksDesc from './allowedCardNetworksDesc.mdx';
import ExistingMethodRequiredDesc from './existingMethodRequiredDesc.mdx';
import IOSThreeDsDesc from './iOSThreeDsDesc.mdx';
import AndroidThreeDsDesc from './androidThreeDsDesc.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Customize the appearance and behavior of the card fields in the checkout form for various payment methods`}</p>
    <Group summary='properties' mdxType="Group">
        <Item title='iOS' subtitle='object' label='optional' mdxType="Item">
              <Group summary='Properties' mdxType="Group">
                <Item title='urlScheme' subtitle='String' label='optional' mdxType="Item">
                  ⚠️ Required for some payment methods (e.g. PayPal). <br /><br />This option sets the deeplink schema used when redirecting back from 3rd party applications to your app.
                </Item>
              </Group>
        </Item>
        <Item title='android' subtitle='object' label='optional' mdxType="Item">
              <Group summary='Properties' mdxType="Group">
                <Item title='redirectScheme' subtitle='String' label='optional' mdxType="Item">
                  ⚠️ Required for some payment methods (e.g. PayPal). <br /><br />This option sets the deeplink schema used when redirecting back from 3rd party applications to your app.
                </Item>
              </Group>
        </Item>
        <Item title='applePayOptions' subtitle='IPrimerApplePayOptions' label='optional' mdxType="Item">
            Options for using Apple Pay as a payment method.
            <Group summary='Properties' mdxType="Group">
                <Item title='merchantIdentifier' subtitle='String' mdxType="Item">
                    {'Set it to the merchant identifier as it is shown in your Apple Pay certificate.'}
                </Item>
                <Item title='merchantName' subtitle='String' mdxType="Item">
                    {'Deprecated: Use Client Session API to provide merchant name value.'}
                </Item>
                <Item title='isCaptureBillingAddressEnabled' subtitle='Boolean' mdxType="Item">
                    <CaptureBillingAddressEnabledDesc mdxType="CaptureBillingAddressEnabledDesc" />
                    {'Deprecated: Use BillingOptions to configure required billing fields.'}
                </Item>
                <Item title='showApplePayForUnsupportedDevice' subtitle='Boolean' mdxType="Item">
                    <ApplePayUnsupportedDesc mdxType="ApplePayUnsupportedDesc" />
                    {'Default value is `true`. Set to `false` if you do not want to present Apple Pay option on unsupported devices.'}
                </Item>
                <Item title='checkProvidedNetworks' subtitle='Boolean' mdxType="Item">
                    <CheckProvidedNetworksDesc mdxType="CheckProvidedNetworksDesc" />
                    {'Default value is `true`. This flag supports the old behavior where Apple Pay flow might not present if there are no cards in the Wallet.'}
                </Item>
                <Item title='shippingOptions' subtitle='ShippingOptions' mdxType="Item">
                    {'Configure shipping options for Apple Pay.'}
                    <Group summary='Properties' mdxType="Group">
                        <Item title='shippingContactFields' subtitle='Array of RequiredContactField' mdxType="Item">
                            {'Specify which contact fields are required for shipping.'}
                        </Item>
                        <Item title='requireShippingMethod' subtitle='Boolean' mdxType="Item">
                            {'Indicate if a shipping method is required.'}
                        </Item>
                    </Group>
                </Item>
                <Item title='billingOptions' subtitle='BillingOptions' mdxType="Item">
                    {'Configure billing options for Apple Pay.'}
                    <Group summary='Properties' mdxType="Group">
                        <Item title='requiredBillingContactFields' subtitle='Array of RequiredContactField' mdxType="Item">
                            {'Specify which contact fields are required for billing.'}
                        </Item>
                    </Group>
                </Item>
            </Group>
        </Item>
        <Item title='cardPaymentOptions' subtitle='IPrimerCardPaymentOptions' label='deprecated' mdxType="Item">
            <CardPaymentOptionsDesc mdxType="CardPaymentOptionsDesc" />
            <Group summary='Properties' mdxType="Group">
                <Item title='is3DSOnVaultingEnabled' subtitle='Boolean' mdxType="Item">
                  {"Enable 3DS flow on vaulted cards."}
                </Item>
            </Group>
        </Item>
        <Item title='goCardlessOptions' subtitle='IPrimerGoCardlessOptions' label='optional' mdxType="Item">
            ⚠️ Required when using Go Cardless in your integration.
            <Group summary='Properties' mdxType="Group">
                <Item title='businessName' subtitle='String' mdxType="Item">
                  {"Business name."}
                </Item>
                <Item title='businessAddress' subtitle='String' mdxType="Item">
                  {"Business address."}
                </Item>
            </Group>
        </Item>
        <Item title='googlePayOptions' subtitle='IPrimerGooglePayOptions' label='optional' mdxType="Item">
            ⚠️ Required when using Google Pay in your integration.
            <Group summary='Properties' mdxType="Group">
                <Item title='merchantName' subtitle='String' mdxType="Item">
                  Set it the merchant name that you want to be shown on the Google Pay screen.
                </Item>
                <Item title='allowedCardNetworks' subtitle='Array<String>' label='Default: ["AMEX", "DISCOVER", "JCB", "MASTERCARD","VISA"]' mdxType="Item">
                  <AllowedCardNetworksDesc mdxType="AllowedCardNetworksDesc" />
                </Item>
                <Item title='isCaptureBillingAddressEnabled' subtitle='Boolean' label='Default: false' mdxType="Item">
                  Sets whether user's billing address should be captured from Google Pay.
                </Item>
                <Item title='isExistingPaymentMethodRequired' subtitle='Boolean' label='Default: false' mdxType="Item">
                  <ExistingMethodRequiredDesc mdxType="ExistingMethodRequiredDesc" />
                </Item>
            </Group>
        </Item>
        <Item title='klarnaOptions' subtitle='IPrimerKlarnaOptions' label='optional' mdxType="Item">
          ⚠️ Required when using Klarna in your integration.
          <Group summary='Properties' mdxType="Group">
            <Item title='recurringPaymentDescription' subtitle='String' label='optional' mdxType="Item">
                    Set the payment description that will be shown on the Klarna screen.
            </Item>
            <Item title='webViewTitle' subtitle='String' label='optional' mdxType="Item">
              <WebViewTitleDesc mdxType="WebViewTitleDesc" />
            </Item>
          </Group>
        </Item>
        <Item title='threeDsOptions' subtitle='IPrimerThreeDsOptions' mdxType="Item">
                Sets the 3DS options in the SDK.
                <Group summary='Properties' mdxType="Group">
                  <Item title='iOS' subtitle='object' label='optional' mdxType="Item">
                        <Group summary='Properties' mdxType="Group">
                          <Item title='threeDsAppRequestorUrl' subtitle='String' label='optional' mdxType="Item">
                            <IOSThreeDsDesc mdxType="IOSThreeDsDesc" />
                          </Item>
                        </Group>
                  </Item>
                  <Item title='android' subtitle='object' label='optional' mdxType="Item">
                        <Group summary='Properties' mdxType="Group">
                          <Item title='threeDsAppRequestorUrl' subtitle='String' label='optional' mdxType="Item">
                            <AndroidThreeDsDesc mdxType="AndroidThreeDsDesc" />
                          </Item>
                        </Group>
                  </Item>
                </Group>
        </Item>
        <Item title='stripeOptions' subtitle='IPrimerStripeOptions' label='optional' mdxType="Item">
          ⚠️ Required when using Stripe ACH in your integration.
          <Group summary='Properties' mdxType="Group">
          <Item title='publishableKey' subtitle='String' label='required' mdxType="Item">
            <p>{`Set the `}<a parentName="p" {...{
                "href": "https://docs.stripe.com/keys#obtain-api-keys"
              }}>{`Stripe publishable key`}</a>{`.`}</p>
          </Item>
            <Item title='mandateData' subtitle='IPrimerStripeTemplateMandateData | IPrimerFullMandateData' label='optional' mdxType="Item">
              	Data used for mandate in Drop-in
                <Group mdxType="Group">
                      <Item subtitle='IPrimerStripeTemplateMandateData' mdxType="Item">
                          Data for the mandate allowing you to specify the name of the merchant that would be used in a predefined mandate template.
                          <Group open summary='Properties' mdxType="Group">
                              <Item title='merchantName' subtitle='String' mdxType="Item">
                              The name of the merchant.
                              </Item>
                          </Group>
                      </Item>
                      <Item subtitle='IPrimerFullMandateData' mdxType="Item">
                          Data for the mandate allowing you to specify the full mandate.
                          <Group open summary='Properties' mdxType="Group">
                              <Item title='fullMandateText' subtitle='String' label="required" mdxType="Item">
                              The string resource pointing to the full mandate. Supported on Android and iOS.
                              </Item>
                              <Item title='fullMandateStringResourceName' subtitle='String' label="optional" mdxType="Item">
                              The name of the Android string resource pointing to the the full mandate. Supported only on Android.
                              </Item>
                          </Group>
                      </Item>
                </Group>
            </Item>
          </Group>
        </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      